import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import NotFound from '../../../Images/notFound.png';
import { Paper, makeStyles, TableBody, TableRow, TableCell, CircularProgress, Switch, Button, Dialog, DialogTitle, DialogContent, Select, MenuItem, DialogActions } from '@material-ui/core';
import useTable from '../../useTable';
import CheckUserProvider from '../../../AllHooks/CheckUserProvider';
import { Helmet } from 'react-helmet';
import { getTodaySupplyOrderDocument, updateSupplyOrderDocument } from '../../../Backend/firebase/supply-order';
import { parseDate } from '../../Models/CommonFunc';
import { useHistory } from 'react-router-dom';
import RefreshOrderFilter from './RefreshOrderFilter';
import db from '../../../Backend/firebase/firebase';
import CustomAlert from '../../CustomAlert';
import WholesalerDropdown from './WholesalerDropdown';
import CollectionDialog from './Popup/CollectionDialog';
import { createCollectionWholesalerDocument, getAllCollectionWholesalerDocument, updateCollectionWholesalerDocument } from '../../../Backend/firebase/collection-wholesaler';


const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
        width: '100%'
    },
    fixedHeight: {
        height: '100%',
    },
}));

const headCells = [
    { id: 'IsAvailable', label: 'Is Available', disableSorting: true },
    { id: 'ProductName', label: 'Product Name', disableSorting: true },
    { id: 'ProductQuantity', label: 'Quantity', disableSorting: true },
    { id: 'ProductScheme', label: 'Scheme', disableSorting: true },
    { id: 'MedicineType', label: 'Medicine Type', disableSorting: false },
    { id: 'SupplyOrderPostedDateTime', label: 'Date', disableSorting: false },
]

function SupplyRetrieveFlow() {
    const classes = useStyles();
    const history = useHistory();
    var batch = db.batch();
    const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
    const [openNotify, setOpenNotify] = React.useState(false)
    const [notificationMessage, setNotificationMessage] = useState('')
    const [alertType, setAlertType] = useState('')
    const { userData } = CheckUserProvider();
    const [filtredWholeSaler, setFiltredWholeSaler] = useState([]);
    const [allTodayCollectionRecords, setAllTodayCollectionRecords] = useState([]);
    const [todayCollectionRecord, setTodayCollectionRecord] = useState(null);
    const [allRecords, setAllRecords] = useState([]);
    const [records, setRecords] = useState([]);
    const SalectedDate = parseDate(new Date());
    const [isLoading, setIsLoading] = useState(false);
    const { TblContainer, TblHead, TblPagination } = useTable(records, headCells);
    const [selectedWholesaler, setSelectedWholesaler] = useState('');
    const [collectionAmount, setCollectionAmount] = useState(0)
    const [isPopupOpen, setIsPopupOpen] = useState(false);

    useEffect(async () => {
        var isLogin = localStorage.getItem(process.env.REACT_APP_EMPLOYER_ISLOGIN) || false;
        if (!isLogin || isLogin == "false") {
            history.push("/activity/Login");
        }
    }, [])

    useEffect(() => {
        fetchTodayRecord();
        fetchTodayCollectionRecord();
    }, []);

    const fetchTodayRecord = async () => {
        setIsLoading(true);
        try {
            const getSupplyOrder = await getTodaySupplyOrderDocument();
            const todaysMedicine = getSupplyOrder.filter(x =>
                parseDate(x.SupplyOrderPostedDateTime).includes(SalectedDate)
            );
            setAllRecords(todaysMedicine);

            if (todaysMedicine?.length > 0) {
                const uniqueWholesalers = {};
                let idCounter = 1;

                todaysMedicine?.forEach(item => {
                    if (item.IsAvailable && item.WholesalerId) {
                        if (!uniqueWholesalers[item.WholesalerId]) {
                            uniqueWholesalers[item.WholesalerId] = { id: idCounter++, name: item.WholesalerId };
                        }
                    }
                });
                const FILTERED_WHOLESALERS = Object.values(uniqueWholesalers);
                setFiltredWholeSaler(FILTERED_WHOLESALERS)
            }

            setIsLoading(false);
        } catch (error) {
            console.log("Error Occur in Get Order", error)
            setIsLoading(false);
        }
    }

    const fetchTodayCollectionRecord = async () => {
        try {
            const getCollectionOrder = await getAllCollectionWholesalerDocument();
            const todaysCollection = getCollectionOrder.filter(x =>
                parseDate(x.postedDateTime).includes(SalectedDate)
            );
            setAllTodayCollectionRecords(todaysCollection);
        } catch (error) {
            console.log("Error Occur in Get Order", error)
            setIsLoading(false);
        }
    }

    useEffect(() => {
        if (selectedWholesaler && selectedWholesaler != null) {
            fetchSelectedWholesalerRecord();
        }
    }, [selectedWholesaler]);

    const fetchSelectedWholesalerRecord = async () => {
        setIsLoading(true);
        try {
            const todaysMedicine = allRecords.filter(x => x?.WholesalerId?.trim()?.toLowerCase() === selectedWholesaler?.trim()?.toLowerCase());
            setRecords(todaysMedicine);

            const todayCollection = allTodayCollectionRecords?.filter(x => x?.wholesalerId?.trim()?.toLowerCase() === selectedWholesaler?.trim()?.toLowerCase());
            todayCollection?.length > 0 ? setTodayCollectionRecord(todayCollection[0]) : setTodayCollectionRecord(null);
            setIsLoading(false);
        } catch (error) {
            console.log("Error Occur in Get Order", error)
            setIsLoading(false);
        }
    }

    const afterSubmitRecord = async () => {
        try {
            const getCollectionOrder = await getAllCollectionWholesalerDocument();
            const todaysCollection = getCollectionOrder.filter(x =>
                parseDate(x.postedDateTime).includes(SalectedDate)
            );
            setAllTodayCollectionRecords(todaysCollection);
            const todayCollection = todaysCollection?.filter(x => x?.wholesalerId?.trim()?.toLowerCase() === selectedWholesaler?.trim()?.toLowerCase());
            setTodayCollectionRecord(todayCollection[0]);
        } catch (error) {
            console.log("Error Occur in Get Order", error)
        }
    }

    const handleToggle = async (item) => {
        const newAvailability = !item.IsAvailable;
        const updatedRecords = records.map(record =>
            record._id === item._id ? { ...record, IsAvailable: newAvailability } : record
        );
        setRecords(updatedRecords);
        try {
            var supplyStock = {
                ...item,
                IsAvailable: !records.find(record => record._id === item._id).IsAvailable,
                WholesalerId: null
            };

            var stockManagmentDetails = updateSupplyOrderDocument(supplyStock);
            if (stockManagmentDetails) {
                console.info("ORDER UPDATE IN SUPPLY MANAGEMNT SUCCESSFULLY ==>");
            } else {
                console.error("ERROR OCCURS IN SUPPLY UPDATE MANAGEMNT ELSE BLOCK ==>");
            }
        } catch (error) {
            console.error('Error updating availability:', error);
            const revertedRecords = records.map(record =>
                record._id === item._id ? { ...record, IsAvailable: !newAvailability } : record
            );
            setRecords(revertedRecords);
        }
    };

    const handleProceedNext = async () => {
        if (selectedWholesaler && selectedWholesaler != null) {
            setIsPopupOpen(true);
        } else {
            setNotificationMessage('Please Select Wholesaler.');
            setOpenNotify(true);
            setAlertType('error');
            return;
        }
    }

    const handleSubmit = async () => {
        if (collectionAmount > 0) {
            try {
                if(todayCollectionRecord && todayCollectionRecord != null) {
                    var newWholesalerPayment = {...todayCollectionRecord}
                    newWholesalerPayment.amount = collectionAmount;
                    try {
                        var payment = updateCollectionWholesalerDocument(newWholesalerPayment);
                        if (payment) {
                            setNotificationMessage('Collection Amount Updated Successfully.')
                            setOpenNotify(true)
                            setAlertType('success')
                            setIsPopupOpen(false);
                            setCollectionAmount(0);
                            afterSubmitRecord();
                        } else {
                            console.error("ERROR Occurs in Create Collection Database Entry => ");
                            setNotificationMessage('Something went wrong, Please Try Again later!');
                            setOpenNotify(true);
                            setAlertType('error');
                        }
                    } catch (error) {
                        console.error("ERROR Occurs in Create Collection Entry => ", error);
                        setNotificationMessage('Something went wrong, Please Try Again later!');
                        setOpenNotify(true);
                        setAlertType('error');
                    }
                } else {
                    var newWholesalerPayment = {}
                    newWholesalerPayment.userId = userData?.uid;
                    newWholesalerPayment.wholesalerId = selectedWholesaler;
                    newWholesalerPayment.chemistInfo = null;
                    newWholesalerPayment.amount = collectionAmount;
                    newWholesalerPayment.status = 'Paid';
                    try {
                        var payment = createCollectionWholesalerDocument(newWholesalerPayment);
                        if (payment) {
                            setNotificationMessage('Collection Amount Added Successfully.')
                            setOpenNotify(true)
                            setAlertType('success')
                            setIsPopupOpen(false);
                            setCollectionAmount(0);
                            afterSubmitRecord();
                        } else {
                            console.error("ERROR Occurs in Create Collection Database Entry => ");
                            setNotificationMessage('Something went wrong, Please Try Again later!');
                            setOpenNotify(true);
                            setAlertType('error');
                        }
                    } catch (error) {
                        console.error("ERROR Occurs in Create Collection Entry => ", error);
                        setNotificationMessage('Something went wrong, Please Try Again later!');
                        setOpenNotify(true);
                        setAlertType('error');
                    }
                }
            } catch (error) {
                console.error("Error performing bulk update:", error);
                setNotificationMessage('Something went wrong, Please Try Again later!');
                setOpenNotify(true);
                setAlertType('error');
            }
        } else {
            setNotificationMessage('Please Enter Collection Amount!.');
            setOpenNotify(true);
            setAlertType('error');
        }
    }

    return (
        <>
            {!userData ?
                (<div className="row">
                    <div className="col-md-12 text-center p-4">
                        <CircularProgress />
                    </div>
                </div>) :
                (<div className="allProductsAndSales">
                    <Paper className={fixedHeightPaper}>
                        <Helmet>
                            <meta name="description" content="Find Order you have posted till now." />
                            <title>Order | Kaipsool Pharmatech</title>
                        </Helmet>
                        <div className="row d-flex justify-content-center align-items-center">
                            <div className="col-md-10 inline-row-style">
                                <h5>Today's Pickup List</h5>
                                <RefreshOrderFilter refreshData={fetchTodayRecord} />
                            </div>
                            <div className="col-md-2">
                                <Button
                                    onClick={handleProceedNext}
                                    variant="contained"
                                    className="registerEmp__btnLogin jsmAdd floatRightt"
                                >
                                    {'Proceed Next'}
                                </Button>
                            </div>
                            <div className="col-md-12 mt-4">
                                <h6>Please Select Wholesaler</h6>
                                <div className="col-md-10 mb-3">
                                    <WholesalerDropdown
                                        data={filtredWholeSaler}
                                        setSelectedRecord={(record) => setSelectedWholesaler(record.name)}
                                    />
                                </div>
                            </div>
                            {isLoading ?
                                <div className="row">
                                    <div className="col-md-12 text-center p-4">
                                        <CircularProgress />
                                    </div>
                                </div> :
                                <>
                                    {(todayCollectionRecord && todayCollectionRecord != null) && <div>
                                        {todayCollectionRecord?.amount && <div style={{ background: 'green', padding: '4px 12px', color: '#FFF' }}>
                                            <small>Collected Today's Amount</small>
                                            <h5>{`Rs. ${todayCollectionRecord?.amount}`}</h5>
                                        </div>
                                        }
                                    </div>}
                                    {records.length > 0 ? <div className="row col-md-12 pickup-order-table">
                                        <TblContainer>
                                            <TblHead />
                                            <TableBody>
                                                {
                                                    records.map(item => (
                                                        <TableRow key={item.id}>
                                                            <TableCell>
                                                                {item?.IsAvailable}
                                                                <Switch
                                                                    checked={item?.IsAvailable}
                                                                    onChange={() => handleToggle(item)}
                                                                    color="primary"
                                                                />
                                                            </TableCell>
                                                            <TableCell>{item?.ProductName ? item.ProductName : "NA"}</TableCell>
                                                            <TableCell>{item?.ProductQuantity ? item.ProductQuantity : "NA"}</TableCell>
                                                            <TableCell>{item?.ProductScheme ? item.ProductScheme : "NA"}</TableCell>
                                                            <TableCell>{item?.MedicineType ? item.MedicineType : "Generic"}</TableCell>
                                                            <TableCell>
                                                                {typeof item?.SupplyOrderPostedDateTime == "string" ? item?.SupplyOrderPostedDateTime : parseDate(item?.SupplyOrderPostedDateTime)}
                                                            </TableCell>
                                                        </TableRow>
                                                    ))
                                                }
                                            </TableBody>
                                        </TblContainer>
                                        <TblPagination />
                                    </div> : <div className="row col-md-12 mt-3 text-center">
                                        <img src={NotFound} className="notFound" />
                                        <h4>No Order Record Found!</h4>
                                    </div>}
                                </>
                            }
                        </div>
                    </Paper>
                </div>)
            }
            <CollectionDialog
                isOpen={isPopupOpen}
                onClose={() => setIsPopupOpen(false)}
                collectionAmount={collectionAmount}
                setCollectionAmount={setCollectionAmount}
                handleSubmit={handleSubmit}
            />
            <CustomAlert
                setOpenNotify={setOpenNotify}
                openNotify={openNotify}
                messageType={alertType}
                notificationMessage={notificationMessage}
            />
        </>
    )
}

export default SupplyRetrieveFlow
